import { useEffect, useState } from 'react';
import Reveal, { Fade } from 'react-awesome-reveal';
import { fadeInRightShorter, fadeInUpShorter } from '../utils/keyframes';
import ContactModal from './ContactModal';

const OurProducts = () => {
    const [isOpen, setOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch products from the API
        const fetchProducts = async () => {
            try {
                const response = await fetch('https://api.razorpay.com/v1/stores/public/hosted/stores/st_QpNpqvqjnmytJM');
                const data = await response.json();
                if (data) {
                    setProducts(data.data.store.products);
                } else {
                    setError('No products available.');
                }
            } catch (error) {
                setError('Failed to fetch products. Please try again later.');
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    // Group products by category
    const groupedProducts = products.reduce((groups, product) => {
        product.categories.forEach((category) => {
            if (!groups[category.name]) {
                groups[category.name] = [];
            }
            groups[category.name].push(product);
        });
        return groups;
    }, {});
    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (groupedProducts.length === 0) {
        return <div>No products available.</div>;
    }
    return (
        <section className='bg-primary-light' id='products'>
            <ContactModal show={isOpen} onHide={() => setOpen(!isOpen)} />

            <div className="px-lg-5 px-3">
                <Fade direction='up'>
                    <h4 className='fw-bold text-center'>
                        <u>Check out our Products</u>
                    </h4>
                </Fade>
                <Fade direction='down'>
                    <p className='fw-medium mb-lg-5 text-center'>
                        Enjoy <span className='text-primary fw-bold fs-4'>Free Shipping</span> Across India
                    </p>
                </Fade>

                <div className="row px-lg-5">
                    {Object.keys(groupedProducts).map((category, index) => (
                        <div key={index} className="col-md-12 py-3 text-center">
                            <Reveal delay={200} duration={1000} keyframes={fadeInRightShorter}>
                                <h4 className='fw-bold my-3'>Sanitary Napkin | {category}</h4>
                                {
                                    category === 'Cotton' ?
                                        <p>Sanitary napkins made from cotton offer comfort, absorbency, and environmental sustainability. Cotton's softness and breathability provide a gentle experience while ensuring efficient absorption. These napkins are hypoallergenic and suitable for sensitive skin. Additionally, their biodegradable nature reduces environmental impact compared to synthetic options, making them a sustainable choice for menstrual hygiene.
                                        </p>
                                        : category === 'Herbal' ? <p>Herbal sanitary napkins incorporate natural ingredients like Aloe vera, Neem and Vettiveru, known for their soothing and therapeutic properties. These napkins offer comfort, hygiene, and freshness during menstruation, addressing concerns such as irritation, odor, and discomfort. By utilizing herbal extracts, they provide a natural and gentle alternative to conventional pads, promoting overall well-being and confidence.
                                        </p> : ''
                                }
                            </Reveal>

                            <div className="row mt-5 justify-content-center">
                                {groupedProducts[category].map((product, j) => (
                                    <div className="col-md-3 p-1" key={j}>
                                        <div className="product-image-wrapper px-0">
                                            <div className="product-price-info">
                                                <Reveal keyframes={fadeInUpShorter}>
                                                    <div className='pad-pack'>{product.name}</div>
                                                    <div>
                                                        <strike className="strike-price">INR {String(product.selling_price).slice(0, -2)}</strike>
                                                    </div>
                                                    <div className='sale-price'>INR.{String(product.discounted_price).slice(0, -2)}</div>
                                                    <div>
                                                        <a className='btn btn-primary btn-sm px-3' href={`https://pages.razorpay.com/stores/st_QpNpqvqjnmytJM/product/${product.id}`}>
                                                            Buy now
                                                        </a>
                                                    </div>
                                                </Reveal>
                                            </div>

                                            <center className='overflow-hidden'>
                                                <Reveal keyframes={fadeInRightShorter}>
                                                    <img
                                                        src={product.images[0]}
                                                        alt={product.name}
                                                        style={{ height: '300px', width: '100%', objectFit: 'contain' }}
                                                    />
                                                </Reveal>
                                            </center>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurProducts;
